import React from 'react';
import Link from '@/lighting-app/compat/NextLink';

export default function StatsSection() {
  return (
    <section className="gradient-primary py-20" id="contact">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
          جاهز لتصميم إضاءة مثالية؟
        </h2>
        <p className="text-white/80 text-lg mb-8 max-w-xl mx-auto">
          ابدأ الآن مجاناً. لا تحتاج تسجيل ولا خبرة هندسية مسبقة.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            href="/design-new-lighting-wizard"
            className="bg-white text-primary font-bold px-8 py-4 rounded-xl hover:bg-gray-50 transition-all duration-200 hover:shadow-lg"
          >
            صمّم إضاءة جديدة
          </Link>
          <Link
            href="/inspect-existing-lighting-wizard"
            className="border-2 border-white/50 text-white font-bold px-8 py-4 rounded-xl hover:bg-white/10 transition-all duration-200"
          >
            افحص إضاءة موجودة
          </Link>
        </div>
      </div>
    </section>
  );
}